// import Vue from 'vue'
// import Vuex from 'vuex'
// import VueAxios from 'vue-axios'
// import axios from 'axios';
import EmptyAdvance from "../../models/delegationAdvance";
import TransportModel from "../../models/delegationTransport";
import CountryModel from "../../models/delegationCountry";
import AccommodationModel from "../../models/delegationAccommodation";
import Delegation from "../../models/delegation";
import DelegationOtherModel from "../../models/delegationOther";
import createErrorFunction from "../../repository/errorObjectArray";
import merge from "deepmerge";
// import apiAddress from 'apiAddress'; // webpack alias
import objectTranslations from "../../repository/translateStringsInObject";
import vueMainInstance from "../../main";

// Vue.use(Vuex);
// Vue.use(VueAxios, axios);

const namespaced = true;

const state = {
  readonly: false,
  delegationList: [],
  delegationEdited: null,
  delegationErrors: null,
  status: "",
  validationCancelToken: null,
  delegationCalculation: null,
  nonChangedDelegation: null,
  delegationAvailableUsers: [],
  transportTypesFromOrder: []
};

const getters = {
  allowedAttachmentFileFormat: (state, getters, rootState) => {
    if (rootState.Auth.userProperties === null) return null;
    return rootState.Auth.userProperties.system_settings.pdf_attachment_only === 1 ? "*" : "application/pdf";
  },
  delegationList: state => state.delegationList,
  delegationEdited: state => state.delegationEdited,
  delegationErrors(state) {
    let translatedErrors = JSON.parse(JSON.stringify(state.delegationErrors));
    translatedErrors = objectTranslations(translatedErrors);
    return translatedErrors;
  },
  delegationCalculation: state => state.delegationCalculation,
  delegationBookings: state => {
    let bookings = [];
    if (state.delegationEdited != null) {
      for (let booking of state.delegationEdited.booking) {
        bookings.push(booking);
      }
      for (let transport of state.delegationEdited.transport.filter(v => v.booking_id != null)) {
        bookings.push({ booking_id: transport.booking_id, label: "transport" });
      }
      for (let country of state.delegationEdited.country) {
        for (let accommodation of country.accommodation.filter(v => v.booking_id != null)) {
          bookings.push({ booking_id: accommodation.booking_id, label: "accommodation" });
        }
      }
    }
    return bookings;
  },
  lastCarRentalName: state => {
    let transports = JSON.parse(JSON.stringify(state.delegationEdited.transport)).reverse();
    for (let transport of transports) {
      if (transport.car_rental_name !== null && transport.car_rental_name !== "") {
        return transport.car_rental_name;
      }
    }
    return null;
  },
  lastCarRentalVehicleName: state => {
    let transports = JSON.parse(JSON.stringify(state.delegationEdited.transport)).reverse();
    for (let transport of transports) {
      if (transport.car_rental_vehicle_name !== null && transport.car_rental_vehicle_name !== "") {
        return transport.car_rental_vehicle_name;
      }
    }
    return null;
  },
  lastCarRentalVehicleModel: state => {
    let transports = JSON.parse(JSON.stringify(state.delegationEdited.transport)).reverse();
    for (let transport of transports) {
      if (transport.car_rental_vehicle_model !== null && transport.car_rental_vehicle_model !== "") {
        return transport.car_rental_vehicle_model;
      }
    }
    return null;
  }
};

const mutations = {
  setReadonly(state, isReadonly) {
    state.readonly = isReadonly;
  },
  setUnchangedDelegation(state, delegationEdited) {
    state.nonChangedDelegation = JSON.parse(JSON.stringify(delegationEdited));
  },
  setDelegationList(state, delegationList) {
    state.delegationList = delegationList;
  },
  setEditedDelegation(state, delegationEdited) {
    state.delegationEdited = delegationEdited;
    if (state.delegationErrors == null) {
      state.delegationErrors = createErrorFunction(state.delegationEdited);
      state.delegationErrors.destination = [];
    }
    let tmp = createErrorFunction(state.delegationEdited);
    tmp.destination = []; //TODO DO REFACTORU WALIDACJA!!!

    state.delegationErrors = merge(state.delegationErrors, tmp);
    //state.delegationErrors = createErrorFunction(state.delegationEdited);
  },
  setErrorsDelegation(state, delegationErrors) {
    state.delegationErrors = delegationErrors;
  },
  setCalculationDelegation(state, delegationCalculation) {
    state.delegationCalculation = delegationCalculation;
    for (let singleCountryCostIndex in delegationCalculation.singleCountryCost) {
      state.delegationEdited.country[singleCountryCostIndex].currency = delegationCalculation.singleCountryCost[singleCountryCostIndex].currency;
      state.delegationEdited.country[singleCountryCostIndex].delegation_rate = delegationCalculation.singleCountryCost[singleCountryCostIndex].delegation_rate;
    }
  },
  downloadDelegationAvailableUsers(state) {
    vueMainInstance.axios.get("delegation/available-users").then(resp => {
      state.delegationAvailableUsers = resp.data;
    });
  },
  removeBooking(state, bookingId) {
    state.delegationEdited.booking.splice(
      state.delegationEdited.booking.findIndex(v => v.booking_id === bookingId),
      1
    );
  },
  setTransportTypesFromOrder(state, newTransportTypesFromOrder) {
    state.transportTypesFromOrder = newTransportTypesFromOrder;
  }
};

const actions = {
  loadAllDelegations({ commit }) {
    vueMainInstance.axios.get("delegation/list").then(response => {
      commit("setDelegationList", response.data);
    });
  },
  saveChanges({ commit, state, dispatch }) {
    return new Promise((resolve, reject) => {
      vueMainInstance.axios
        .post("delegation/save-standard", state.delegationEdited)
        .then(resp => {
          if (resp.data.status === "OK") {
            commit("setUnchangedDelegation", null);
            dispatch("loadAllDelegations");
            commit("setEditedDelegation", null);
            resolve();
          }
          reject(resp);
        })
        .catch(err => {
          console.log(err);
          if (err.response.data.status === "validationError") {
            dispatch(
              "alertDialog",
              {
                content: vueMainInstance.$t("global.error.validationError.content"),
                title: vueMainInstance.$t("global.error.validationError.title")
              },
              { root: true }
            );
          } else if (err.response.data.status === "unknownError") {
            if (err.response.data.message.toLowerCase.includes("validation")) {
              dispatch(
                "alertDialog",
                {
                  content: vueMainInstance.$t("global.error.validationError.content"),
                  title: vueMainInstance.$t("global.error.validationError.title")
                },
                { root: true }
              );
            } else {
              dispatch(
                "alertDialog",
                {
                  content: vueMainInstance.$t("global.error.generalError.content"),
                  title: vueMainInstance.$t("global.error.generalError.title")
                },
                { root: true }
              );
            }
          }
          console.log("Wystąpił nieoczekiwany błąd:");
          console.log(err.response.data.code);
          console.log(err.response.data.message);
          reject(err.response);
        });
    });
  },
  cancelChanges({ dispatch }) {
    //loadAllDelegationOrders();
    dispatch("loadAllDelegation");
    //this.dispose('loadAllDelegationOrders');
  },
  addAdvance({ commit, state }) {
    let tmp = state.delegationEdited;
    tmp.advances.push(JSON.parse(JSON.stringify(EmptyAdvance)));
    commit("setEditedDelegation", tmp);
  },
  removeAdvance({ commit, state }, advance) {
    let tmp = state.delegationEdited;
    tmp.advances.splice(tmp.advances.indexOf(advance), 1);
    commit("setEditedDelegation", tmp);
  },
  addOther({ commit, state }, type) {
    let tmp = state.delegationEdited;
    let other = JSON.parse(JSON.stringify(DelegationOtherModel));
    other.type = type;
    tmp.other.push(other);
    commit("setEditedDelegation", tmp);
  },
  removeOther({ commit, state, dispatch }, other) {
    let tmp = state.delegationEdited;
    tmp.other.splice(tmp.other.indexOf(other), 1);
    commit("setEditedDelegation", tmp);
    if (other.file_id != null) {
      dispatch("removeFile", other.file_id);
    }
  },
  addTransport({ commit, state }) {
    let tmp = state.delegationEdited;
    tmp.transport.push(JSON.parse(JSON.stringify(TransportModel)));
    commit("setEditedDelegation", tmp);
  },
  removeTransport({ dispatch, commit, state }, transport) {
    let tmp = state.delegationEdited;
    if (tmp.transport.length <= 2) {
      dispatch(
        "alertDialog",
        {
          content: vueMainInstance.$t("delegation.form.minimumTransportRequired.content"),
          title: vueMainInstance.$t("delegation.form.minimumTransportRequired.title")
        },
        { root: true }
      );
    } else {
      tmp.transport.splice(tmp.transport.indexOf(transport), 1);
      if (transport.file_id != null) {
        dispatch("removeFile", transport.file_id);
      }
      commit("setEditedDelegation", tmp);
    }
  },
  duplicateTransport({ commit, state }, transport) {
    let tmp = state.delegationEdited;
    let tmpTransportClone = JSON.parse(JSON.stringify(transport));
    tmpTransportClone.start_date = null;
    tmpTransportClone.end_date = null;
    tmpTransportClone.file_id = null;
    tmpTransportClone.booking_id = null;
    tmp.transport.push(tmpTransportClone);
    commit("setEditedDelegation", tmp);
  },
  addFile({ commit, state }, file) {
    let tmp = state.delegationEdited;
    tmp.file.push(file);
    commit("setEditedDelegation", tmp);
  },
  removeFile({ commit, state }, fileId) {
    let tmp = state.delegationEdited;
    for (let index in tmp.file) {
      if (tmp.file[index].id === fileId) {
        tmp.file.splice(index, 1);
      }
    }
    commit("setEditedDelegation", tmp);
  },
  addCountry({ commit, state }) {
    let tmp = state.delegationEdited;
    tmp.country.push(JSON.parse(JSON.stringify(CountryModel)));
    if (tmp.country.length === 1) {
      tmp.country[0].country_code = "PL";
    }
    commit("setEditedDelegation", tmp);
  },
  removeCountry({ dispatch, commit, state }, country) {
    let tmp = state.delegationEdited;
    if (tmp.country.length <= 1) {
      dispatch(
        "alertDialog",
        {
          content: vueMainInstance.$t("delegation.form.minimumCountryRequired.content"),
          title: vueMainInstance.$t("delegation.form.minimumCountryRequired.title")
        },
        { root: true }
      );
    } else {
      tmp.country.splice(tmp.country.indexOf(country), 1);
      for (let index in tmp.country.accommodation) {
        if (tmp.country.accommodation[index].file_id != null) {
          dispatch("removeFile", tmp.country.accommodation[index].file_id);
        }
      }
      commit("setEditedDelegation", tmp);
    }
  },
  addBooking({ commit, state, dispatch }, { bookingId, label }) {
    let tmp = state.delegationEdited;
    if (typeof state.delegationEdited.booking.find(v => v.booking_id === bookingId) === "undefined") {
      tmp.booking.push({ booking_id: bookingId, label: label });
      commit("setEditedDelegation", tmp);
    } else {
      dispatch(
        "alertDialog",
        {
          content: "Rezerwacja została już załączona", //TODO TŁUMACZENIE
          title: "Błąd" //TODO TŁUMACZENIE
        },
        { root: true }
      );
    }
  },
  addAccommodationToCountry({ commit, state }, country) {
    let tmp = state.delegationEdited;
    let countryIndex = tmp.country.indexOf(country);
    tmp.country[countryIndex].accommodation.push(JSON.parse(JSON.stringify(AccommodationModel)));
    commit("setEditedDelegation", tmp);
  },
  removeAccommodationFromCountry({ commit, state, dispatch }, { country, accommodation }) {
    let tmp = state.delegationEdited;
    let countryIndex = tmp.country.indexOf(country);
    tmp.country[countryIndex].accommodation.splice(tmp.country[countryIndex].accommodation.indexOf(accommodation), 1);
    if (accommodation.file_id != null) {
      dispatch("removeFile", accommodation.file_id);
    }
    commit("setEditedDelegation", tmp);
  },
  newDelegation({ dispatch, commit }) {
    let tmp = JSON.parse(JSON.stringify(Delegation));
    commit("setEditedDelegation", tmp);
    commit("setTransportTypesFromOrder", []);
    dispatch("addTransport");
    dispatch("addTransport");
    dispatch("addCountry");
    //dispatch("validateDelegation");
  },
  newDelegationFromOrder({ dispatch, commit, rootGetters }, delegationOrderId) {
    vueMainInstance
      .axios({
        url: "delegation/delegation-order-import",
        data: { id: delegationOrderId },
        method: "POST"
      })
      .then(resp => {
        let tmp = JSON.parse(JSON.stringify(Delegation));
        if (rootGetters["userProperties"].system_settings.is_synchro_numbers === 2) {
          tmp.custom_number = resp.data.delegationOrder.number;
          tmp.number = resp.data.delegationOrder.number;
        }
        tmp.delegation_order_id = delegationOrderId;
        tmp.user_id = resp.data.delegationOrder.user_id;
        tmp.destination = resp.data.delegationOrder.destination;
        tmp.destinationObjects = resp.data.delegationOrder.destinationObjects;
        tmp.start_date = resp.data.delegationOrder.start_date;
        tmp.end_date = resp.data.delegationOrder.end_date;
        tmp.task = resp.data.delegationOrder.task;
        tmp.cost_centre_id = resp.data.delegationOrder.cost_centre_id;
        tmp.task_id = resp.data.delegationOrder.task_id == null ? null : resp.data.delegationOrder.task_id.toString();
        tmp.delegation_order_number = resp.data.delegationOrder.number;
        tmp.company_id = resp.data.delegationOrder.company_id === null ? null : parseInt(resp.data.delegationOrder.company_id);
        tmp.project_id = resp.data.delegationOrder.project_id === null ? null : parseInt(resp.data.delegationOrder.project_id);
        tmp.external_customer_id = resp.data.delegationOrder.external_customer_id === null ? null : parseInt(resp.data.delegationOrder.external_customer_id);
        for (let delegetaionAdvance of resp.data.delegationOrder.delegationAdvances) {
          tmp.advances.push(JSON.parse(JSON.stringify(delegetaionAdvance)));
        }
        commit("setEditedDelegation", tmp);
        commit("setTransportTypesFromOrder", JSON.parse(resp.data.delegationOrder.selected_transport_types));

        //commit("setEditedDelegation", tmp); //TODO DLACZEGO TO BYLO 2x?
        dispatch("addTransport");
        dispatch("addTransport");
        dispatch("addCountry");
        //dispatch("validateDelegation");
      })
      .catch(err => {
        console.log("Error delegation order response:");
        console.log(err);
      });
  },
  editDelegation({ commit }, delegationId) {
    vueMainInstance
      .axios({
        url: "delegation/delegation-edit",
        data: { id: delegationId },
        method: "POST"
      })
      .then(resp => {
        let tmp = JSON.parse(JSON.stringify(Delegation));
        //let tmp = state.delegationEdited;
        tmp = merge(tmp, resp.data.delegation);
        //TODO TUTAJ DALSZE USTAWIENIA np advance
        commit("setEditedDelegation", tmp);
        commit("setUnchangedDelegation", tmp);
        commit("setTransportTypesFromOrder", JSON.parse(resp.data.selected_transport_types));
      })
      .catch(err => {
        console.log("Error delegation order response:");
        console.log(err);
      });
  },
  validateDelegation: ({ state, commit }) => {
    if (state.validationCancelToken != null) {
      state.validationCancelToken();
    }
    const CancelToken = vueMainInstance.axios.CancelToken;
    vueMainInstance
      .axios({
        url: "delegation/form-field-changed",
        data: {
          delegation: state.delegationEdited,
          delegationErrors: createErrorFunction(state.delegationEdited)
        },
        method: "POST",
        cancelToken: new CancelToken(function executor(c) {
          // An executor function receives a cancel function as a parameter
          state.validationCancelToken = c;
        })
      })
      .then(resp => {
        //console.log('validation AGAIN');
        //console.log(state.delegationErrors);
        //console.log(resp.data);
        commit("setErrorsDelegation", resp.data.validation);
        commit("setCalculationDelegation", resp.data.calculated);
      })
      .catch(err => {
        //TODO obsluga bledow
        console.log("Error validation response:");
        console.log(err);
      });
    //console.log('test_validation');
  },
  mergeArray(target, source) {
    for (let property in source) {
      if (source[property] instanceof Object) {
        //todo rekursja?
      } else {
        target[property].push(source[property]);
      }
    }
    return target;
  }
};

export default {
  namespaced,
  state,
  getters,
  actions,
  mutations
};
